import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import Swal from 'sweetalert2';

export default function ParaLlevar() {
  const [ordenes, setOrdenes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creando, setCreando] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    cargarOrdenes();
  }, []);

  const cargarOrdenes = async () => {
    try {
      // Traer ordenes abiertas de tipo para_llevar
      const res = await api.get('/ordenes/para-llevar/activas');
      setOrdenes(res.data);
    } catch {
      // Si no existe el endpoint aún, dejamos vacío
      setOrdenes([]);
    } finally {
      setLoading(false);
    }
  };

  const crearOrden = async () => {
    if (creando) return;
    setCreando(true);
    try {
      const res = await api.post('/ordenes/para-llevar');
      navigate(`/ordenes/${res.data.id}`);
    } catch {
      Swal.fire('Error', 'No se pudo crear el pedido', 'error');
    } finally {
      setCreando(false);
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '60vh' }}>
        <div className="spinner-border text-primary" role="status" />
      </div>
    );
  }

  return (
    <div className="p-4">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h2 className="mb-0">Para Llevar / Delivery</h2>
          <small className="text-muted">{ordenes.length} pedido{ordenes.length !== 1 ? 's' : ''} activo{ordenes.length !== 1 ? 's' : ''}</small>
        </div>
        <button
          className="btn btn-primary"
          onClick={crearOrden}
          disabled={creando}
        >
          {creando ? (
            <><span className="spinner-border spinner-border-sm me-2" />Creando...</>
          ) : '+ Nuevo Pedido'}
        </button>
      </div>

      {ordenes.length === 0 ? (
        <div className="text-center mt-5">
          <div style={{ fontSize: 64 }}>📦</div>
          <h5 className="text-muted mt-3">No hay pedidos activos</h5>
          <p className="text-muted">Crea un nuevo pedido para comenzar</p>
          <button className="btn btn-primary mt-2" onClick={crearOrden} disabled={creando}>
            + Nuevo Pedido
          </button>
        </div>
      ) : (
        <div className="row g-3">
          {ordenes.map((orden) => (
            <div key={orden.id} className="col-12 col-md-6 col-lg-4">
              <div
                className="card h-100"
                style={{
                  borderTop: '4px solid #3b82f6',
                  borderRadius: '12px',
                  cursor: 'pointer',
                }}
                onClick={() => navigate(`/ordenes/${orden.id}`)}
              >
                <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <h5 className="mb-0">Pedido #{orden.id}</h5>
                    <span className="badge bg-primary">📦 Para Llevar</span>
                  </div>
                  <p className="text-muted mb-1" style={{ fontSize: 13 }}>
                    {orden.items?.length || 0} producto{(orden.items?.length || 0) !== 1 ? 's' : ''}
                  </p>
                  <p className="text-muted mb-0" style={{ fontSize: 13 }}>
                    Total: <strong>${parseFloat(orden.total || 0).toFixed(2)}</strong>
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}